module.exports = __webpack_public_path__ + "static/media/ajay.ba334c32.jpg";